import { TextBase } from '../../../v2/text-base'
import { Title } from '../../../v2/title'
import styles from './styles.module.scss'
import React from 'react'
import { Button } from '../../../v2/button'
interface Props {
  smoothScroll?: () => void
}

export const SectionWhatIsFreeEnergyMarket = ({ smoothScroll }: Props) => {
  return (
    <div className={styles.wrapperContainer}>
      <div className="flex flex-col lg:px-3">
        <div className="w-full max-w-7xl self-center">
          <div className={styles.container}>
            <div className={styles.wrapperInfos}>
              <Title className={styles.title} level="h2">
                <>
                  O que é o <span className="text-orange">Mercado Livre</span>{' '}
                  de Energia?
                </>
              </Title>
              <TextBase className={styles.description}>
                O <strong>Ambiente de Contratação Livre (ACL)</strong>, mais
                conhecido como <strong>Mercado Livre de Energia</strong>, é o
                ambiente de contratação do setor elétrico brasileiro onde você é
                livre para escolher o seu fornecedor de{' '}
                <strong>Energia Elétrica.</strong>
              </TextBase>
              <div>
                <Button
                  type="button"
                  className={styles.button}
                  onClick={smoothScroll}
                >
                  Faça Parte do Mercado Livre
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
